export default __webpack_public_path__ + "static/media/image_6483441.798ce026.jpg";